import { fetcher } from "helpers/fetcher";

import { TGetStaffDriverLicenceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeDriverLicence = async (userId: string) => {
  return await fetcher<TGetStaffDriverLicenceRes, any>(
    ENDPOINT.USER.GET_EMPLOYEE_DRIVER_LICENCE,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_EMPLOYEE_DRIVER_LICENCE.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetEmployeeDriverLicence = async (userId: string) => {
  return (await getEmployeeDriverLicence(userId)).data;
};

queryGetEmployeeDriverLicence._key = (userId: string) => [
  ENDPOINT.USER.GET_EMPLOYEE_DRIVER_LICENCE.url,
  userId,
];
